<template>
  <div data-component-prose class="[&>*:first-child]:mt-0 [&>*:last-child]:mb-0">
    <slot />
  </div>
</template>
